import { atom } from 'jotai';
import { PreferenceKey, PreferenceScope } from '../../../../data-models/preferences-v3.data-model';
import { PreferencesServiceV3 } from '../../../../util/preferences-service-v3';
import { TearsheetV2Layout } from './types';

export const DEFAULT_LAYOUT: TearsheetV2Layout = {
  items: [],
  version: 4,
};

const PREFERENCE_KEY = `${PreferenceKey.tearSheetV2Layout}.default`;
const PREFERENCE_SCOPE = PreferenceScope.ORGANIZATION;

// Local state atom - updates immediately without API call
const baseLayoutAtom = atom<TearsheetV2Layout | null>(null);

// Derived atom that initializes from preferences and provides getter/setter
export const tearsheetV2LayoutAtom = atom(
  (get) => {
    const localValue = get(baseLayoutAtom);
    if (localValue !== null) {
      return localValue;
    }
    // Initialize from preferences service
    const prefValue = PreferencesServiceV3.get().getPreference<TearsheetV2Layout>(
      PREFERENCE_KEY as PreferenceKey,
      PREFERENCE_SCOPE
    );
    return prefValue ?? DEFAULT_LAYOUT;
  },
  (_get, set, newValue: TearsheetV2Layout) => {
    // Only update local state - API call is handled separately
    set(baseLayoutAtom, newValue);
  }
);

// Async function to persist layout to preferences - returns promise for error handling
export async function saveLayoutToPreferences(layout: TearsheetV2Layout): Promise<void> {
  await PreferencesServiceV3.get().setPreference(PREFERENCE_KEY as PreferenceKey, layout, PREFERENCE_SCOPE);
}
